import { css as e } from "styled-components";
//#region src/components/Composer/styled/Composer.styled.ts
var t = e`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border: none;
    border-radius: ${({ theme: e }) => e.radii.full};
    cursor: pointer;
`;
//#endregion
export { t as roundButton };
